// Social sharing
export const IS_SOCIAL_SHARING_ENABLED = 'socialSharing-isEnabled';
export const IS_SOCIAL_SHARING_ENABLED_PATH = `style.booleans.${IS_SOCIAL_SHARING_ENABLED}`;
export const getIsSocialSharingProviderEnabledParam = (provider, isMobile = false) => `socialSharing-${isMobile ? 'mobile-' : ''}${provider}`;
export const getIsSocialSharingProviderEnabledParamPath = (provider, isMobile = false) => `style.booleans.${getIsSocialSharingProviderEnabledParam(provider, isMobile)}`;
//# sourceMappingURL=social-sharing.wix-params.js.map